import withNavigate from "../../../routes/withNavigate.jsx";
import RegionsContainer from "./RegionsContainer.jsx";
import RegionsStore from "./RegionsStore.js";

export default RegionsStore(withNavigate(RegionsContainer));